import React from 'react';
import './MenuIcon.css';

const View = ({ onClick }) => (
  <div className='menu-icon-container mobile-menu-button' onClick={onClick}>
    <div className='menu-bar menu-bar1' />
    <div className='menu-bar menu-bar2' />
    <div className='menu-bar menu-bar3' />
  </div>
);

export default View;



// WEBPACK FOOTER //
// ./src/components/MenuIcon.js